export default __webpack_public_path__ + "static/media/gs-1.4a9b6497.png";